import BaseObject from '../../../base/base_object';
import _ from '../../../utils/underscore';
import {TOKEN_PROPERTIES} from '../oauth_const';
import Store from '../../../utils/store';

export default class EmptyToken extends BaseObject {
    static CLASS = 'EmptyToken';
    isEmpty() {
        return true;
    }

    getLastRefreshTime() {
        return 0;
    }

    delete() {
        this._deleteOrphanTokenPropertiesFromStorage();
    }

    _deleteTokenRelatedProperties() {
        Store.del(TOKEN_PROPERTIES.OAUTH_LAST_REFRESH_TOKEN_TIMESTAMP);
        Store.del(TOKEN_PROPERTIES.OAUTH_HAS_REMEMBER_ME);
        Store.del(TOKEN_PROPERTIES.OAUTH_LAST_TIME_ACTIVITY);
        Store.del(TOKEN_PROPERTIES.OAUTH_ACCESS_TOKEN);
        Store.del(TOKEN_PROPERTIES.OAUTH_TOKEN_FIELDS_OVERRIDES);
    }


    _deleteOrphanTokenPropertiesFromStorage() {
        let tokenDataInLocalStorage = Store.get(TOKEN_PROPERTIES.OAUTH_STORAGE_KEY, null);
        // if the token data is not there in the local storage anymore remove the other related properties
        if(!tokenDataInLocalStorage) {
            this._deleteTokenRelatedProperties();
        }
    }

    setFieldValue(fieldName, fieldValue) {
    }

    getFieldValue() {
        return null;
    }

    updatePostLoginData() {

    }

    getRefreshToken() {
        return null;
    }

    _userData = null;
    getUserData() {
        if(!this._userData) {
            this._userData = _.safeJSON(Store.get(TOKEN_PROPERTIES.OAUTH_LAST_USER_DATA), null);
        }
        return this._userData;
    }

    getAccountData() {
        return null;
    }

    getHttpAuthorizationHeader() {
        return null;
    }

    getDecodedAccessToken() {
        return null;
    }

    getTimeUntilExpiration() {
        return 0;
    }

    isExpired() {
        return true;
    }

    hasRememberMe() {
        return false;
    }
}